var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "columnsBar", class: _vm.$.editing_view },
    [
      _c("columns-bar-header", {
        ref: "header",
        attrs: {
          title: _vm.locale("columns_bar_editing_title"),
          "view-config": _vm.viewConfig,
          "back-button": !_vm.viewConfig.isBoard,
          "help-button": false,
        },
        on: {
          onClose: function ($event) {
            return _vm.$emit("onClose")
          },
          backClick: _vm.backClick,
        },
      }),
      _vm._v(" "),
      _c("div", { class: _vm.$.body }, [
        _vm.warningMessage
          ? _c(
              "div",
              { ref: "notification", class: _vm.$.warning },
              [
                _c("inline-notification", {
                  attrs: {
                    type: "warning",
                    text: _vm.warningMessage,
                    "message-styles": {
                      "font-size": "12px",
                      "white-space": "wrap",
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.viewConfig.currencyEditing
          ? _c("div", { class: _vm.$.currency_editing }, [
              _c(
                "div",
                { class: _vm.$.switch },
                [
                  _c("div", { class: _vm.$.label }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.locale("budget_currency")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("toggle", {
                    attrs: { "is-toggle-on": _vm.enableCurrency },
                    on: { onChange: _vm.currencySwitch },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { class: _vm.$.slot },
                [
                  _c("vgp-label-slot", {
                    attrs: { label: _vm.locale("budget_currency_sign") },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c("dropdown-select", {
                                attrs: {
                                  multiselect: false,
                                  "show-reset-btn": false,
                                  disabled: !_vm.enableCurrency,
                                  "drop-list": _vm.currencies,
                                  selected: [_vm.currentCurrency],
                                },
                                on: { selected: _vm.setSelected },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2739783069
                    ),
                  }),
                ],
                1
              ),
            ])
          : _c("div", { class: _vm.$.custom_column_editing }, [
              _c(
                "div",
                { ref: "input", class: [_vm.$.slot, _vm.$.slot__name] },
                [
                  _c("vgp-label-slot", {
                    attrs: {
                      label: _vm.locale("columns_bar_edit_name_input_label"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "body",
                        fn: function () {
                          return [
                            _c("vgp-input", {
                              attrs: {
                                value: _vm.name,
                                small: true,
                                placeholder: _vm.placeholder,
                              },
                              on: {
                                input: _vm.inputName,
                                onChange: _vm.changeName,
                              },
                              model: {
                                value: _vm.name,
                                callback: function ($$v) {
                                  _vm.name = $$v
                                },
                                expression: "name",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "dropdown",
                  class: [_vm.$.slot, _vm.$.slot__custom_column],
                },
                [
                  _c("vgp-label-slot", {
                    attrs: {
                      label: _vm.locale(
                        "columns_bar_new_column_types_select_label"
                      ),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "body",
                        fn: function () {
                          return [
                            _c("dropdown-select", {
                              attrs: {
                                "drop-list": _vm.customColumnsTypes,
                                multiselect: false,
                                "show-selected-first": false,
                                "show-reset-btn": false,
                                "highlight-active-state": false,
                                "item-template": "withIcon",
                                "track-by-text": "name",
                                "track-by-icon-name": "icon",
                                disabled: true,
                                "popup-max-height": 305,
                                selected: _vm.getSelectedColumnType(),
                              },
                              on: { selected: _vm.onSelectCustomColumnType },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.columnType === "select"
                ? _c(
                    "div",
                    {
                      ref: "options",
                      class: [
                        _vm.$.slot,
                        _vm.$.slot__options,
                        _vm.$.slot__option_select,
                      ],
                    },
                    [
                      _c("vgp-label-slot", {
                        attrs: {
                          label: _vm.locale("columns_bar_select_options_label"),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "body",
                              fn: function () {
                                return [
                                  _c("select-options", {
                                    attrs: {
                                      "max-height": _vm.optionsListMaxHeight,
                                      options: _vm.options,
                                    },
                                    on: { onChange: _vm.changeOptions },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1432155954
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.columnType === "number"
                ? _c(
                    "div",
                    { class: [_vm.$.slot, _vm.$.slot__option_number] },
                    [
                      _c("vgp-label-slot", {
                        attrs: {
                          label: _vm.locale(
                            "columns_bar_aggregations_options_label"
                          ),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "body",
                              fn: function () {
                                return [
                                  _c("dropdown-select", {
                                    attrs: {
                                      "drop-list": _vm.optionsAggregations,
                                      multiselect: false,
                                      "show-selected-first": false,
                                      "show-reset-btn": false,
                                      "highlight-active-state": false,
                                      "item-template": "text",
                                      "track-by-text": "value",
                                      "popup-max-height": 100,
                                      selected: _vm.selectedOptions,
                                    },
                                    on: { selected: _vm.changeOptions },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          966186004
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.columnType === "colors"
                ? _c(
                    "div",
                    {
                      ref: "options",
                      class: [
                        _vm.$.slot,
                        _vm.$.slot__options,
                        _vm.$.slot__option_colors,
                      ],
                    },
                    [
                      _c("vgp-label-slot", {
                        attrs: {
                          label: _vm.locale("columns_bar_colors_options_label"),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "body",
                              fn: function () {
                                return [
                                  _c("color-options", {
                                    attrs: {
                                      "max-height": _vm.optionsListMaxHeight,
                                      options: _vm.options,
                                    },
                                    on: { onChange: _vm.changeOptions },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2833536775
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.columnType === "multiselect"
                ? _c(
                    "div",
                    {
                      ref: "options",
                      class: [
                        _vm.$.slot,
                        _vm.$.slot__options,
                        _vm.$.slot__option_multiselect,
                      ],
                    },
                    [
                      _c("vgp-label-slot", {
                        attrs: {
                          label: _vm.locale(
                            "columns_bar_multiselect_options_label"
                          ),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "body",
                              fn: function () {
                                return [
                                  _c("multiselect-options", {
                                    attrs: {
                                      "max-height": _vm.optionsListMaxHeight,
                                      options: _vm.options,
                                    },
                                    on: { onChange: _vm.changeOptions },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          660506939
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.columnType === "resources"
                ? _c(
                    "div",
                    { class: [_vm.$.slot, _vm.$.slot__option_resources] },
                    [
                      _c("vgp-label-slot", {
                        attrs: {
                          label: _vm.locale(
                            "columns_bar_resources_options_label"
                          ),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "body",
                              fn: function () {
                                return [
                                  _c("dropdown-select", {
                                    attrs: {
                                      "drop-list": _vm.preparedResources,
                                      placeholder: _vm.locale(
                                        "columns_bar_resources_select_placeholder"
                                      ),
                                      multiselect: true,
                                      "show-selected-first": false,
                                      "show-reset-btn": false,
                                      "highlight-active-state": false,
                                      "devider-color": "#999999",
                                      "use-search": true,
                                      "item-template": "user",
                                      "track-by-text": "name",
                                      "group-by": "group",
                                      "use-select-all": true,
                                      "popup-max-height": 200,
                                      selected: _vm.selectedOptions,
                                    },
                                    on: { change: _vm.changeOptions },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3027165112
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.columnType === "tags"
                ? _c(
                    "div",
                    {
                      ref: "options",
                      class: [
                        _vm.$.slot,
                        _vm.$.slot__options,
                        _vm.$.slot__option_tags,
                      ],
                    },
                    [
                      _c("vgp-label-slot", {
                        attrs: {
                          label: _vm.locale("columns_bar_tags_options_label"),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "body",
                              fn: function () {
                                return [
                                  _c("tag-options", {
                                    attrs: {
                                      "max-height": _vm.optionsListMaxHeight,
                                      options: _vm.options,
                                    },
                                    on: { onChange: _vm.changeOptions },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2863314856
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
      ]),
      _vm._v(" "),
      !_vm.viewConfig.currencyEditing
        ? _c("div", { ref: "footer", class: _vm.$.footer }, [
            _c(
              "div",
              { class: [_vm.$.button, _vm.$.button__cancel] },
              [
                _c("vgp-button", {
                  class: _vm.$.vgp,
                  attrs: {
                    id: "gp_autotest_columns_bar_save_cancel_editing",
                    label: _vm.locale("common_cancel"),
                    type: "secondary",
                  },
                  on: { onClick: _vm.cancelChanges },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { class: [_vm.$.button, _vm.$.button__save] },
              [
                _c("vgp-button", {
                  class: _vm.$.vgp,
                  attrs: {
                    id: "gp_autotest_columns_bar_save_editing",
                    label: _vm.locale("common_save"),
                    type: "primary",
                  },
                  on: { onClick: _vm.onClickSave },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }